import React, {useState} from 'react';
import {Button, Select, Typography} from 'antd';
import {ModelFileUploaded} from '../../../../../../store/modelFile';
import {useModelMetadataActiveOptions} from '../../../../../../store/modelMetadata';
import styles from './FileTagSelectionBoxAntd.module.scss';

const {Text} = Typography;

type FileTagSelectionBoxAntdProps = {
  selectedFileCount: number;
  onClick: (fileTag: string) => void;
  onCancel: () => void;
  handleFileTag?: (node: ModelFileUploaded, fileTag: string) => void;
  setUnSelectAll?: any;
  unSelectAll?: boolean;
};

const FileTagSelectionBoxAntd: React.FC<Partial<FileTagSelectionBoxAntdProps>> = (props) => {
  const {onClick, onCancel} = props;
  const [selectedOption, setSelectedOption] = useState<string | undefined>(undefined);
  const options = useModelMetadataActiveOptions();

  const handleSaveFileType = () => {
    if (onClick && selectedOption) {
      onClick(selectedOption);
    }
    onCancel?.();
  };

  const handleChange = (value: string) => {
    setSelectedOption(value);
  };

  const handleSearch = (input: string) => {
    // Allow creating new file tags by typing
    if (input && !options?.fileTag?.includes(input)) {
      setSelectedOption(input);
    }
  };

  return (
    <div className={styles.fileTagSelectionBox}>
      <div style={{display: 'flex', alignItems: 'center', gap: '16px', width: '100%'}}>
        <Text strong style={{fontSize: '14px', color: '#262626', whiteSpace: 'nowrap', flex: '0 0 auto'}}>
          What type of file is this?
        </Text>
        <Select
          showSearch
          placeholder="Select or type file type"
          value={selectedOption}
          onChange={handleChange}
          onSearch={handleSearch}
          getPopupContainer={() => document.body}
          listHeight={320}
          style={{flex: 1, minWidth: 200}}
          options={(options?.fileTag || []).map((tag) => ({label: tag, value: tag}))}
          optionFilterProp="label"
          filterOption={(input, option) => (option?.label as string)?.toLowerCase().includes(input.toLowerCase())}
          dropdownMatchSelectWidth={false}
        />
        <Button
          type="primary"
          onClick={handleSaveFileType}
          disabled={!selectedOption}
          style={{
            background: '#006A63',
            borderColor: '#006A63',
            height: '40px',
            padding: '0 24px',
            fontSize: '14px',
            fontWeight: 500,
            flex: '0 0 auto',
          }}
        >
          Save file type
        </Button>
      </div>
    </div>
  );
};

export default FileTagSelectionBoxAntd;
